import React, { useState } from "react";
import { FaHome } from "react-icons/fa";
import { IoIosListBox, IoIosAlbums } from "react-icons/io";
import { RiDashboardFill } from "react-icons/ri";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { FaCog } from "react-icons/fa";
import { MdMargin } from "react-icons/md";
import { BsFillLightningChargeFill } from "react-icons/bs";

const Layout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  // Header and sidebar data
  const orgName = "Aadvik Tech Service";
  const user = { amount: "1000", userName: "User", email: "admin@gmail.com" };
  const profileItem = { dashboard: "Dashboard", settings: "Settings" };
  const sidebarItem = [
    { id: 1 , logo: <RiDashboardFill />, name: "Dashboard", link: "" },
    {
      id: 2,
      logo: <FaHome />,
      name: "Client Management",
      link: "user-management",
    },
    { id: 3, logo: <IoIosListBox />, name: "RDP List", link: "rdpList" },
    { id: 4, logo: <IoIosAlbums />, name: "User Activity", link: "activity" },
    {
      id: 5,
      logo: <FaCog />,
      name: "Settings",
      link: "serverType",
      dropdown: [
        // {
        //   id: 6,
        //   logo: <BsFillLightningChargeFill />,
        //   name: "Server Name",
        //   link: "server",
        // },
        {
          id: 7,
          logo: <BsFillLightningChargeFill />,
          name: "Server Type",
          link: "serverType",
        },

        {
          id: 8,
          logo: <BsFillLightningChargeFill />,
          name: "Connectivity SW",
          link: "remoteControl",
        },
        {
          id: 9,
          logo: <MdMargin />,
          name: "DataCenter Location",
          link: "dataCenter",
        },
        {
          id: 10,
          logo: <BsFillLightningChargeFill />,
          name: "Control Panel",
          link: "remotePanel",
        },
      ],
    },
  ];

  //   mobile view in select sidebar item then after hide sidebar...
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden ">
      {/* Header */}
      <Header
        title={orgName}
        user={user}
        profileItem={profileItem}
        onMobileSide={setSidebarOpen}
      />

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <Sidebar
          sidebarItem={sidebarItem}
          sidebarOpen={isSidebarOpen}
          closeSidebar={closeSidebar}
        />

        {/* Main Content Area */}
        <div className="flex-1 sm:ml-64 mt-10 overflow-auto bg-background ">
          <main className="min-h-full border-gray-200 rounded-lg dark:border-gray-700 !bg-[#cbd5e0]">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;
